<script>
export default {
  name: 'HxTable',
  inject: {
    hxForm: {
      default: '',
    },
  },
  props: {
    // 数据源
    data: {
      type: Array,
      default: () => [],
    },
    // 列数据
    columns: {
      type: Array,
      default: () => [],
    },
    // 是否显示勾选列
    showSelectionCol: {
      type: Boolean,
      default: false,
    },
    // 是否显示序号列
    showIndexCol: {
      type: Boolean,
      default: false,
    },
    // 是否数据为空的图片
    empty: {
      type: Boolean,
      default: false,
    },
    // 默认列宽
    defaultColumnWidth: String,
    // 边框
    border: {
      type: Boolean,
      default: true,
    },
    // tip样式
    tooltipEffect: {
      type: String,
      default: 'light',
    },
    // 是否高亮当前行
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },
    // 表格大小
    size: {
      type: String,
      default: 'small',
    },
    // 头部样式
    headerCellStyle: {
      type: [Object, Function],
      default() {
        return {
          background: '#EEEFF3',
          textAlign: 'center',
          fontSize: '14px',
          color: '#505050',
        }
      },
    },
    // 单元格样式
    cellStyle: {
      type: [Object, Function],
      default() {
        return ({ row, column, rowIndex, columnIndex }) => {
          let style = { textAlign: 'center' }

          return style
        }
      },
    },
    // 默认列属性
    columnDefaultProps: {
      type: Object,
      default() {
        return {
          width: 'auto',
          showOverflowTooltip: true,
          resizable: true,
          align: 'center',
        }
      },
    },
    // 行勾选框是否可勾选
    selectable: {
      type: Function,
      default: () => true,
    },
    // form disabled
    disabled: Boolean,
    // rowKey
    rowKey: [Function, String],
    // 根据rowKey刷新数据后记住勾选行
    reserveSelection: Boolean,
    // 自动根据data设置列宽
    autoColWidth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      colWidth: {},
    }
  },

  computed: {
    customColumns() {
      return this.columns
        .map((item) => {
          const obj = {}
          if (this.defaultColumnWidth) {
            obj.minWidth = this.defaultColumnWidth
          }

          let colObj = Object.assign({}, this.columnDefaultProps, obj, item)

          if (colObj.defaultSlot || colObj.headerSlot || colObj.type) {
            colObj.showOverflowTooltip = false
          }

          if (
            !item.width &&
            this.colWidth[colObj.prop] &&
            (!colObj.type || !colObj.render)
          ) {
            colObj.width = this.colWidth[colObj.prop]
          }

          return colObj
        })
        .filter((item) =>
          typeof item.hide === 'function' ? item.hide(item) : !item.hide,
        )
        .filter((item) => {
          if (typeof item.show === 'function') {
            return item.show(item)
          }

          return !item.hasOwnProperty('show') || item.show
        })
    },

    selection() {
      return this.$refs.table.selection
    },

    setCurrentRow() {
      return this.$refs.table.setCurrentRow
    },

    toggleRowSelection() {
      return this.$refs.table.toggleRowSelection
    },

    doLayout() {
      return this.$refs.table.doLayout
    },

    elTable() {
      return this.$refs.table
    },
  },

  watch: {
    data(val) {
      if (val && this.autoColWidth) {
        this.setColWidth()
      }
    },
  },

  created() {},

  mounted() {
    if (this.hxForm) {
      this.hxForm.$emit('hx.form.addFormValidate', this.validate)
    }
  },

  updated() {},

  beforeDestroy() {
    if (this.hxForm) {
      this.hxForm.$emit('hx.form.removeFormValidate', this.validate)
    }
  },

  methods: {
    scrollToBottom() {
      this.$refs.table.bodyWrapper.scrollTop =
        this.$refs.table.bodyWrapper.scrollHeight
    },
    setColWidth() {
      const colProps = this.columns.map((item) => item.prop)

      let colWidth = {}
      for (let i = 0; i < colProps.length; i++) {
        const prop = colProps[i]
        const textArr = this.data.map((item) => {
          if (item[prop] === undefined || item[prop] === null) {
            return ''
          }

          return String(item[prop])
        })

        let text = textArr.reduce((pre, t) => {
          if (t.length > pre.length) {
            return t
          } else {
            return pre
          }
        }, textArr[0] || '')

        const labelText = this.columns.find((item) => item.prop === prop).label

        const labelSpanEl = document.createElement('span')
        const labelTextEl = document.createTextNode(labelText)
        labelSpanEl.appendChild(labelTextEl)
        document.body.appendChild(labelSpanEl)
        const labelWidth = labelSpanEl.getBoundingClientRect().width
        document.body.removeChild(labelSpanEl)

        const spanEl = document.createElement('span')
        const textEl = document.createTextNode(text)
        spanEl.appendChild(textEl)
        document.body.appendChild(spanEl)
        let width = spanEl.getBoundingClientRect().width
        document.body.removeChild(spanEl)

        if (width < labelWidth) {
          width = labelWidth
        }
        colWidth[prop] = parseInt(width + 20)
      }

      this.colWidth = colWidth
    },
    validate(showMessage = false) {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, invalidFields) => {
          if (valid) {
            resolve(valid)
            return
          }

          const messages = Object.keys(invalidFields).map(
            (f) => invalidFields[f][0].message,
          )

          if (showMessage) {
            this.$message.error(messages[0])
          }

          reject(new Error(messages[0]))

          this.$nextTick(() => {
            this.scrollToErrorView()
          })
        })
      })
    },
    scrollToErrorView() {
      const errors = document.getElementsByClassName('is-error')
      if (errors[0]) {
        errors[0].scrollIntoView({ inline: 'center' })
      }
    },
  },

  render() {
    const getTypeComponent = (col, row, $index) => {
      const RenderComponent = col.type

      const {
        on = {},
        events = {},
        ...other
      } = Object.assign({}, col.props, col)
      const firstOn = Object.keys(other).reduce((pre, cur) => {
        const arr = cur.trim().split('on')
        if (arr[0] === '' && arr[1]) {
          const eventName = arr[1].toLocaleLowerCase()
          pre[eventName] = other[cur]
        }
        return pre
      }, {})

      const listeners = Object.assign({}, firstOn, events, on)

      const props = Object.assign({}, col.props)
      const attrs = Object.assign({}, col.attrs)

      for (let key in listeners) {
        const fn = listeners[key]
        listeners[key] = (...args) => {
          return fn(...args, row, $index)
        }
      }

      if (col.type === 'HxSelect' || col.type === 'hx-select') {
        const fn = props.disabledOption
        props.disabledOption = (...args) => {
          return fn && fn(...args, row, $index)
        }

        if (typeof props.disabledLabel === 'function') {
          props.disabledLabel = props.disabledLabel(row, $index)
        }
      }

      if (col.type === 'HxButtons' || col.type === 'hx-buttons') {
        const list = props.list || []
        props.list = list.map((b) => {
          const onClickFn = b.onClick
          const o = { ...b }
          o.onClick = (...args) => {
            return onClickFn && onClickFn(...args, row, $index)
          }

          if (typeof o.disabled === 'function') {
            const disabled = o.disabled
            o.disabled = (...args) => {
              return disabled(...args, row, $index)
            }
          }

          if (typeof o.show === 'function') {
            const show = o.show
            o.show = (...args) => {
              return show(...args, row, $index)
            }
          }

          return o
        })
      }

      let disabled = col.disabled
      if (typeof col.disabled === 'function') {
        disabled = col.disabled({ row, $index })
      }

      return (
        <RenderComponent
          vModel={row[col.prop]}
          row={row}
          tableIndex={$index}
          onChange={(val) => {
            this.$emit('change', val, row, $index)

            col.props &&
              col.props.onChange &&
              col.props.onChange(val, row, $index)
          }}
          onClick={() =>
            col.props && col.props.onClick && col.props.onClick(row, $index)
          }
          onSelected={(item) => {
            col.props &&
              col.props.onSelected &&
              col.props.onSelected(item, row, $index)
          }}
          {...{
            props: { disabled, ...props },
            on: listeners,
            attrs: attrs,
            ...props,
          }}
        />
      )
    }

    return (
      <div ref="tableWarp" class="hx-table">
        <el-form
          ref="form"
          {...{
            props: {
              model: { table: this.data },
              disabled:
                this.disabled !== undefined
                  ? this.disabled
                  : (this.hxForm || {}).disabled,
            },
          }}
        >
          <el-table
            ref="table"
            style="height: 100%"
            data={this.data}
            border={this.border}
            size={this.size}
            tooltip-effect={this.tooltipEffect}
            highlight-current-row={this.highlightCurrentRow}
            header-cell-style={this.headerCellStyle}
            cell-style={this.cellStyle}
            rowKey={this.rowKey}
            {...{
              props: this.$attrs,
              on: this.$listeners,
            }}
          >
            {this.showSelectionCol ? (
              <el-table-column
                type="selection"
                align="center"
                width="55"
                reserve-selection={this.reserveSelection}
                selectable={this.selectable}
              />
            ) : null}

            {this.showIndexCol ? (
              <el-table-column
                type="index"
                align="center"
                width="56"
                label="序号"
              />
            ) : null}

            {this.$slots.default}

            {this.customColumns.map((col, index) => {
              const scopedSlots = {}

              if (col.format) {
                scopedSlots.default = ({ row, $index }) => (
                  <span>{col.format(row[col.prop], row, $index)}</span>
                )
              }

              if (!col.colType && col.type) {
                scopedSlots.default = (function (col) {
                  return ({ row, $index }) => {
                    return getTypeComponent(col, row, $index)
                  }
                })(col)
              }

              if (col.render) {
                scopedSlots.default = col.render
              }

              if (col.headerRender) {
                scopedSlots.header = col.headerRender
              }

              if (col.defaultSlot) {
                scopedSlots.default = this.$scopedSlots[col.defaultSlot]
              }

              if (col.headerSlot) {
                scopedSlots.header = this.$scopedSlots[col.headerSlot]
              }

              const defaultSlotFn = scopedSlots.default

              if (
                typeof defaultSlotFn === 'function' &&
                (col.required || col.rules)
              ) {
                scopedSlots.default = (scopedProps) => {
                  const contentVnode = defaultSlotFn(scopedProps)

                  const scopedSlots = {
                    error: ({ error }) => (
                      <div class="el-form-item__error">{error}</div>
                    ),
                  }

                  let rules = col.rules
                  let required = col.required
                  let mergeRules = []

                  if (required) {
                    if (typeof required === 'function') {
                      required = required(scopedProps)
                    }
                    const requiredDefault = {
                      required: required,
                    }
                    mergeRules.push(requiredDefault)
                  }

                  if (
                    Object.prototype.toString.call(rules) ===
                    '[object Function]'
                  ) {
                    rules = rules(scopedProps)
                  }

                  if (
                    Object.prototype.toString.call(rules) === '[object Array]'
                  ) {
                    mergeRules = mergeRules.concat(rules)
                  }

                  if (
                    Object.prototype.toString.call(rules) === '[object Object]'
                  ) {
                    mergeRules.push(rules)
                  }

                  if (mergeRules) {
                    mergeRules.forEach((r) => {
                      if (r.required && typeof r.message === 'undefined') {
                        r.message = `${col.label}不能为空`
                      }
                    })
                  }

                  return (
                    <el-form-item
                      rules={mergeRules}
                      prop={`table.${scopedProps.$index}.${col.prop}`}
                      scopedSlots={scopedSlots}
                    >
                      {contentVnode}
                    </el-form-item>
                  )
                }
              }

              return (
                <el-table-column
                  key={index}
                  type={col.colType}
                  {...{ props: col }}
                  scopedSlots={scopedSlots}
                />
              )
            })}
            <div slot="empty" class="el-table__empty-block">
              <span style="position: absolute; width: 100%; left: 0">
                暂无数据
              </span>
            </div>
          </el-table>
        </el-form>
      </div>
    )
  },
}
</script>
